/* Swiperスライダー（ループ処理対応のため） */
function coordinationSlideshow() {
  let slide_number = document.querySelector('#coordination-container').getAttribute("data-slideperview"),
      slide_total = document.querySelector('#coordination-container').getAttribute("data-slideperview"),
      options;

  // スライド枚数によるoption分岐
  if (slide_total <= 3) {
    options = {
      loop: true,
      centerInsufficientSlides: true,
      speed: 1000,
      lazy: true,
      runCallbacksOnInit: false,
      slidesPerView: 1,
      spaceBetween: 20,
      centeredSlides: true,
      breakpoints: {
        900: {
          // スライド3枚以下ではPC閲覧時にループさせない（slidesPerView有効時のループ処理には、slidesPerView値より2倍以上のスライド数が必要なため
          loop: false,
          slidesPerView: slide_number,
          spaceBetween: 24
        }
      },

      scrollbar: {
        el: ".c-slider-nav__bar"
      },

      // Navigation arrows
      navigation: {
        nextEl: '.coordination-slider-button--next',
        prevEl: '.coordination-slider-button--prev',
      },
    }

  // スライド4枚以上の場合はループ有効化
  } else {
    options = {
      loop: true,
      speed: 1000,
      lazy: true,
      runCallbacksOnInit: false,
      slidesPerView: 1,
      spaceBetween: 20,
      centeredSlides: true,
      breakpoints: {
        900: {
          slidesPerView: slide_number,
          spaceBetween: 24
        }
      },

      scrollbar: {
        el: ".c-slider-nav__bar"
      },

      // Navigation arrows
      navigation: {
        nextEl: '.coordination-slider-button--next',
        prevEl: '.coordination-slider-button--prev',
      },
    }
  }

  // Swiper定義
  const swiper = new Swiper('.coordination-swiper', options);

}

/* コーディネート記事一覧の位置調整後にSwiperを起動する */
function coordinationMove() {
  const coordinatioElm = document.querySelector('#coordination-container'),
        appendTarget = document.getElementById('productCoordinationWrap');
  let loading;
  if(coordinatioElm && appendTarget) {
    loading = appendTarget.querySelector('.loading-overlay__wrapper');
    loading.classList.add('hidden');
    appendTarget.appendChild(coordinatioElm);
    coordinationSlideshow();
  }
}

coordinationMove();